module.exports = __webpack_public_path__ + "static/media/bulk_order_type_upload.28ed3a98.csv";